import TRANSLATIONS_DA_OLD from "../Danish";
import { Auth_DA } from "./Auth/auth";
import { Challenge_Criteria_DA } from "./Challenges/challenge.criteria";
import { Challenge_Overview_DA } from "./Challenges/challenge.overview";
import { Challenge_Single_DA } from "./Challenges/challenge.single";
import { Challenge_Toasts_DA } from "./Challenges/challenge.toasts";
import { Consent_DA } from "./Components/consent";
import { News_DA } from "./News/news";
import { PrecisionGame_DA } from "./PrecisionGame/precision.game";
import { Profile_DA } from "./Profile/profile";
import { Profile_Settings_DA } from "./Profile/profile.settings";
import { Errors_DA } from "./Utils/Errors";
import { Feedback_DA } from "./Utils/Feedback";
import { siteRoutes_DA } from "./Utils/siteRoutes";

const TRANSLATIONS_DA = {
  ...TRANSLATIONS_DA_OLD,

  // Auth
  ...Auth_DA,

  // Profile
  ...Profile_DA,
  ...Profile_Settings_DA,

  // Challenges
  ...Challenge_Overview_DA,
  ...Challenge_Single_DA,
  ...Challenge_Toasts_DA,
  ...Challenge_Criteria_DA,

  // News
  ...News_DA,

  // Components
  ...Consent_DA,

  // Precision Game
  ...PrecisionGame_DA,

  // Utils
  ...siteRoutes_DA,
  ...Errors_DA,
  ...Feedback_DA,
};

export default TRANSLATIONS_DA;
